<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submit()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast">

    <b-form-group label="How will this internship opportunity benefit and impact your career?  <strong>Make sure that you are writing in complete sentences with appropriate capitalization and punctuation.</strong>" label-class="font-weight-bold">
      <b-form-textarea v-model="form.impact" :rows="3"></b-form-textarea>
    </b-form-group>

    <b-form-group label="" label-class="font-weight-bold">
        <b-form-checkbox v-model="form.confirm"
                         stacked>I have discussed these tasks and duties with my site supervisor and they have agreed.</b-form-checkbox>
        <span class="span-feedback invalid-feedback" v-if="$v.form.confirm.$error">Please acknowledge this before proceeding.</span>
    </b-form-group>

  </form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import formWrapper from "./form-wrapper";
import { required, sameAs } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      form: {
        impact: null,
        confirm: null
      }
    };
  },

  validations: {
    form: {
      impact: {
        required
      },
      confirm: {
        sameAs: sameAs(() => true)
      }
    }
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    },
    asuriteId: {
      type: String,
      required: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  computed: {
    ...mapState({
      userId: state => state.additionalMaterials.userId,
      studentOpportunityId: state =>
        state.additionalMaterials.studentOpportunityId,
      studentOpportunity: state => state.additionalMaterials.studentOpportunity
    })
  },

  methods: {
    ...mapActions("additionalMaterials", [
      "setStudentOpportunity",
      "setStudentOpportunityId"
    ]),
    ...mapActions("pip", ["createShell", "updateShell", "confirmShell"]),
    submit: function() {
      this.$v.$touch();

      var that = this;

      if (!this.$v.$invalid) {
        this.studentOpportunity.objective = this.form.impact;

        this.confirmShell(this.studentOpportunity).then(response => {
          that.setStudentOpportunity(this.studentOpportunity);
          this.setStudentOpportunityId(
            this.studentOpportunity.studentOpportunityId
          );
          that.$emit("submitted");
        });
      }
    },
    previous: function() {
      this.$emit("previous");
    }
  },
  watch: {
    studentOpportunity: {
      handler: function() {
        if (this.studentOpportunity) {
          this.form.impact = this.studentOpportunity.objective;
        }
      },
      deep: true
    }
  },
  created() {
    if (this.studentOpportunity) {
      this.form.impact = this.studentOpportunity.objective;
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
